import React, { useLayoutEffect } from 'react';

import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import { TICKET_CORPORATE_CREDIT_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';

import TicketCorporateCreditInformationResource from './resource/TicketCorporateCreditInformationResource';

import TicketCorporateCreditToolBar from './TicketCorporateCreditToolBar';
import {
  clearTicketCorporateCredit,
  getTicketCorporateCredit,
} from '../../../../actions/corporate/TicketCorporateCredit';

export const TicketCorporateCredit = ({
  breadcrumbs,
  dispatchGetTicketCorporateCredit,
  dispatchClearTicketCorporateCredit,
  match: {
    params: { id: ticketCorporateCreditId },
  },
  loading,
  ticketCorporateCredit,
}) => {
  useLayoutEffect(() => {
    dispatchGetTicketCorporateCredit({ ticketCorporateCreditId });

    return () => dispatchClearTicketCorporateCredit();
  }, []);

  let content;

  let toolbar;

  if (loading) {
    content = <Loader />;
  } else if (ticketCorporateCredit.isEmpty()) {
    content = <NoDataResource returnPage={TICKET_CORPORATE_CREDIT_PATH} />;
  } else {
    const ticketCorporateCreditJson = ticketCorporateCredit.toJS();

    content = (
      <TicketCorporateCreditInformationResource
        {...ticketCorporateCreditJson}
      />
    );

    toolbar = (
      <TicketCorporateCreditToolBar
        ticketCorporateCreditId={ticketCorporateCreditJson.id}
        initialBalance={ticketCorporateCreditJson.initialBalance}
        companyId={ticketCorporateCreditJson.companyId}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Crédito Corporativo de Pasajes"
      content={content}
    />
  );
};

TicketCorporateCredit.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchClearTicketCorporateCredit: PropTypes.func.isRequired,

  dispatchGetTicketCorporateCredit: PropTypes.func.isRequired,

  loading: PropTypes.bool,

  match: matchPropTypes.isRequired,

  ticketCorporateCredit: PropTypes.instanceOf(Immutable.Map).isRequired,
};

TicketCorporateCredit.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetTicketCorporateCredit: getTicketCorporateCredit,
  dispatchClearTicketCorporateCredit: clearTicketCorporateCredit,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Créditos Corporativos de Pasajes',
      href: TICKET_CORPORATE_CREDIT_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],

  ticketCorporateCredit: CorporateUnit.TicketCorporateCredit.getIn([
    'current',
    'content',
  ]),

  loading: !CorporateUnit.TicketCorporateCredit.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketCorporateCredit);
